import React, { Component } from 'react';
require('./automationpage.css');

class AutomationServices extends Component {
    constructor(props) {
        super(props);
        this.contactUs = this.contactUs.bind(this);
    }

    contactUs(){
        window.location.replace("/#contactUsForm");
    }

    render() {
        return (
            <div className="text-center" style={{ paddingTop: '15px' }}>
                <div className="container">
                    <h1 className="text-center">We also offer other services such as </h1>
                    <div className="row">
                        <div className="row otherServicesCards">
                            <div className="col-md-4">
                                <div className="card" id="otherSerivceCard">
                                    <img src='https://png.icons8.com/color/1600/telegram-app.png'
                                        id="telegram_icon" className='service_icon' alt='telegram_icon' />
                                    <hr style={{ backgroundColor: 'blue' }} />
                                    <p style={{ fontSize: '20px' }} >
                                        <b>Telegram Bots</b> <br />
                                    </p>
                                    <p style={{ fontSize: '17px', textAlign: 'left' }}>
                                        Telegram bots have gained popularity in the past years, mainly due to the easiness and usefulness of using them.
                                        They can be used to set up reminders for large group of people, get notifications on certain topics, cryptocurrency news,
                                        and marketing automation.
                                </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card" id="otherSerivceCard">
                                    <img src='https://image.freepik.com/free-vector/instagram-icon_1057-2227.jpg'
                                        id="instagram_icon" className='service_icon' alt='instagram_icon' />
                                    <hr style={{ backgroundColor: 'blue' }} />
                                    <p style={{ fontSize: '20px' }} >
                                        <b>Instagram Bots</b> <br />
                                    </p>
                                    <p style={{ fontSize: '17px', textAlign: 'left' }}>
                                        In order to increase their brand popularity, companies and influencers have to do many repetitive tasks everyday.
                                        Therefore, they ofte use bots to do the work for them. We have developed bots that will like and comment a list of users' pictures or
                                        post daily stories or posts for your audience.
                                </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card" id="otherSerivceCard">
                                    <img src='https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/2000px-Python-logo-notext.svg.png'
                                        id="python_icon" className='service_icon' alt='python_icon' />
                                    <hr style={{ backgroundColor: 'blue' }} />
                                    <p style={{ fontSize: '20px' }} >
                                        <b>Python Task Automation</b> <br />
                                    </p>
                                    <p style={{ fontSize: '17px', textAlign: 'left' }}>
                                        Python Bots can be used to automate daily tasks such as smart email notifications,
                                        resume creator, web scrapping, and sending emails/texts to certain people.
                                </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <hr />
                    <h3 className='text-center'>If you are not sure what to automate or how it can be done, <br />
                        give us a call or send us an email to guide you and your company in the right direction!</h3>
                    <button className="btn" id='contactUsButton'
                        onClick={() => this.contactUs()}
                    >Contact Us</button>
                </div>
            </div>
        );
    }
}

export default AutomationServices;


// WEBPACK FOOTER //
// ./src/AutomationServices/AutomationServices.js